module.exports = "<app-navbar></app-navbar>\r\n<router-outlet></router-outlet> "


//////////////////
// WEBPACK FOOTER
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1